import { SVGProps } from 'react';

export const Poor = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 104 104"
        {...props}
    >
        <path
            fill="#E06E3F"
            d="M67.168 47.667a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Zm-30.333 0a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Z"
        />
        <path
            fill="#E06E3F"
            d="M52.001 60.667c-10.096 0-18.72 6.283-22.186 15.166h7.236c2.99-5.156 8.537-8.666 14.95-8.666 6.414 0 11.917 3.51 14.95 8.666h7.237c-3.467-8.883-12.09-15.166-22.187-15.166Zm-.043-52C28.038 8.667 8.668 28.08 8.668 52c0 23.92 19.37 43.333 43.29 43.333 23.963 0 43.377-19.413 43.377-43.333 0-23.92-19.414-43.333-43.377-43.333Zm.043 78c-19.153 0-34.666-15.514-34.666-34.667 0-19.153 15.513-34.667 34.666-34.667 19.154 0 34.667 15.514 34.667 34.667 0 19.153-15.513 34.667-34.667 34.667Z"
        />
    </svg>
);
